const isAbsolutePath = (path) => path.startsWith('http://') || path.startsWith('https://');

export default isAbsolutePath;
